export const STORAGE_KEYS = {
  USER_NAME: 'user-name',
};
